import { SaveButton, SimpleForm, Toolbar } from 'react-admin'
import Form from '../inputFormComponents/Form'
import UserCompanyCard from './form/UserCompanyCard'
import UserContactCard from './form/UserContactCard'
import UserBankAccountCard from './form/UserBankAccountCard'

const UserEditToolbar = (props:any) => (
  <Toolbar {...props}>
    <SaveButton alwaysEnable />
  </Toolbar>
)

const FormInput = () => {

  const cards = [
    <UserCompanyCard />,
    <UserContactCard />,
    <UserBankAccountCard />
  ]

  return (
    <SimpleForm toolbar={<UserEditToolbar />} >
      <Form cards={cards} />
    </SimpleForm>
  )
}

export default FormInput